import React from "react";
import { FAQS } from "../data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  return (
    <main className="max-w-4xl mx-auto px-6 md:px-10 py-16 md:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#0033A0]">Frequently asked</p>
      <h1 className="font-display text-4xl md:text-6xl font-black tracking-tighter text-slate-900 mt-3">
        Common questions
      </h1>
      <p className="text-lg text-slate-700 mt-5 max-w-2xl leading-relaxed">
        Quick, plain-language answers. For specific numbers, always confirm with official sources or your recruiter.
      </p>

      <Accordion type="single" collapsible className="mt-12 border-t border-slate-200" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200">
            <AccordionTrigger
              data-testid={`faq-question-${i}`}
              className="font-display font-bold text-slate-900 text-left text-base md:text-lg py-5 hover:no-underline hover:text-[#0033A0]"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-700 leading-relaxed text-[15px] pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-16 bg-slate-50 border border-slate-200 rounded-xl p-6 md:p-8 text-center">
        <h3 className="font-display font-bold text-xl text-slate-900">Don{`'`}t see your question?</h3>
        <p className="text-slate-600 mt-2 text-sm leading-relaxed">
          Tap the Boot Buddy chat in the bottom-right corner — it{`'`}ll answer in plain English.
        </p>
      </div>
    </main>
  );
}
